// extracted by mini-css-extract-plugin
module.exports = {"legalPage":"legal-pages-module--legalPage","container":"legal-pages-module--container","section":"legal-pages-module--section","contactInfo":"legal-pages-module--contactInfo"};